import { render } from "./Sv023.vue?vue&type=template&id=74760274&scoped=true"
import script from "./Sv023.vue?vue&type=script&lang=js"
export * from "./Sv023.vue?vue&type=script&lang=js"

import "./Sv023.vue?vue&type=style&index=0&id=74760274&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74760274"]])

export default __exports__